<div>
    <nz-result nzStatus="403" nzTitle="Not Allowed"
        nzSubTitle="You do not have permission to access this resource. Please contact the administrator.">
        <div nz-result-extra>
            <button nz-button (click)="goToProjects()">
                Go to Projects
            </button>
        </div>
    </nz-result>
</div>